export const urls = {
  GET_JEZIK: 'Combo/vrati_jezike_combo',
  GET_MAIN_CATEGORY: 'Combo/vrati_vrste_dokumenta_opste_combo',
  GET_DOKUMENTA: 'Dokumenta/vrati_dokumenta_objekta',
  INSERT_DOKUMENTA: 'Dokumenta/unos_dokumenta',
  DELETE_DOKUMENT: 'Dokumenta/brisanje_dokumenta_objekta',
};
